/* eslint-disable arrow-parens */
/* eslint-disable react/jsx-closing-bracket-location */
import React from 'react';
import { withTranslation } from 'react-i18next';
import debounce from 'lodash/debounce';
import GoalServices from '../../../services/goal.services';
import { ErrorTextComp } from '../../inputs/fields.component';
import ImgIconComp from '../../imgcomp';
import PermissionComp from '../wizard/key_results/permission.component';
import { reactLoader, removeReactLoader } from '../../../utils/common'
import {Modal, ModalWrapper, ThemeProvider, ModalContent, Dropdown} from '@workboard/wobo-ui';
import styled from "styled-components";

const StyledModal = styled(Modal)`
${ModalWrapper} {
  position: absolute;
  top: 65px;
}
${ModalContent} { 
  overflow: visible !important;
}
`;

const StyledDropdown = styled(Dropdown)`
  min-width: 206px !important;
  width: unset !important;
  height: 39px !important
  > svg {
    margin-right: 10px !important;
  }
  .MuiSelect-root {
    background-color: #f2f2f2 !important;
    border: 1px solid rgba(0,0,0,0.06);
}
`;
class ConvertOKRmodal extends React.Component {
  constructor(props) {
    super(props);
    const goalDetails = this.props.goalDetails;
    const convertOKR = goalDetails.convertOKR;
    let ownerFullName = convertOKR.currentUser.owner_fullname;
    let ownerPic = convertOKR.currentUser.owner_pic;
    let ownerId = convertOKR.currentUser.owner_id;
    let ownerList = [];
    if (goalDetails.type == 2 && Object.keys(convertOKR).length) {
      ownerFullName = convertOKR.owner_fullname;
      ownerPic = convertOKR.owner_pic;
      ownerId = convertOKR.owner_id;
      ownerList = convertOKR.ownerList;
      ownerList = convertOKR.ownerList.map(item =>{
        item.StartNode = <img alt="" src={item.picture} className="fitProfileimg"/>
         return item;
      })  
    }
    let permission = [];
    if(goalDetails.permission  && goalDetails.permission.length > 0) {
      permission = goalDetails.permission.split(",").map(Number);
    } else if(goalDetails.type == 1) {
      permission = (goalDetails.default_permission && Object.keys(goalDetails.default_permission).length > 0) ? goalDetails.default_permission.split(",").map(Number) : [8];
    } else {
      permission = [10];
    }
    this.state = {
      showConvertOKR: false,
      teamEn: false,
      ownerEn: false,
      owner_name: ownerFullName,
      owner_id: ownerId,
      krOwnerPic: ownerPic,
      team_name: convertOKR.team_name,
      team_id: convertOKR.team_id,
      filter: {
        Team: [],
        Owner: [],
      },
      ownerSearchVal: '',
      teamSearchVal: '',
      ownerList,
      errors: {},
      ownerDataSpinner: false,
      Exclude: true,
      hide: true,
      teamPermissionSelected:
        goalDetails.permission_teams &&
        Object.keys(goalDetails.permission_teams).length > 0
        ? goalDetails.permission_teams
        : 
        goalDetails.type == 1 &&
        goalDetails.default_permission_teams &&
        Object.keys(goalDetails.default_permission_teams).length > 0 &&
        ((permission && permission.length > 0) && (permission.includes(8) ||
        permission.includes(1) || permission.includes(2) || permission.includes(10)
        || (goalDetails.all_metrics == 0 && permission.includes(7))))
        ? goalDetails.default_permission_teams : [],
    bizPermissionSelected: goalDetails.permission_biz &&
      Object.keys(goalDetails.permission_biz).length > 0
      ? goalDetails.permission_biz
      : [],
      permissionstate: (goalDetails.type == 1) ? [10] : [8],
      permissionHelpPopUp: false,
    };
    this.currentComp = React.createRef();
    this.convertOKR = this.convertOKR.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.changeSearchBox = this.changeSearchBox.bind(this);
    this.select = this.select.bind(this);
    this.filterTeamFunction = this.filterTeamFunction.bind(this);
    this.filterOwnerFunction = this.filterOwnerFunction.bind(this);
    this.clickOwnerEnable = this.clickOwnerEnable.bind(this);
    this.handleExcludeChange = this.handleExcludeChange.bind(this);
    this.permissionData = this.permissionData.bind(this);
    this.teamPermissionData = this.teamPermissionData.bind(this);
    this.bizPermissionData = this.bizPermissionData.bind(this);
    this.clearStates = this.clearStates.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.findIndexArr = this.findIndexArr.bind(this);

    this.GoalServices = new GoalServices();
    this.delayedCalleback = debounce(function(event, term) {
      const _this = this;
      if (term === 'team') {
        this.setState({ teamSearchVal: event.target.value }, () =>
          _this.filterTeamFunction(event)
        );
      } else if (term === 'owner') {
        this.setState({ ownerSearchVal: event.target.value }, () =>
          _this.filterOwnerFunction(event)
        );
      }
    }, 300);
  }

  componentDidMount() {
     this.isRendered = true;
     document.addEventListener('mousedown', this.handleOutsideClick);
  }

  componentWillUnmount() {
     if (this.isRendered) {
        document.removeEventListener('mousedown', this.handleOutsideClick);
     }
  }

  handleOutsideClick(e) {
		let enableObj = {};
		let filterObj = {
			filter: {}
    };
    console.log('handleOutsideClick');
		if (
			!$(".aETeamSelect").is(e.target) &&
			$(".aETeamSelect").has(e.target).length === 0 &&
			(!$(".myTeamDropDown ").is(e.target) &&
				$(".myTeamDropDown").has(e.target).length === 0)
		) {
			enableObj["teamEn"] = false;
			filterObj.filter["Team"] = [];
		}

		if (
			!$(".aEOwnerSelect").is(e.target) &&
			$(".aEOwnerSelect").has(e.target).length === 0 &&
			(!$(".myOwner ").is(e.target) && $(".myOwner").has(e.target).length === 0)
		) {
			enableObj["ownerEn"] = false;
			filterObj.filter["owner"] = [];
		}
		if (Object.keys(enableObj).length && Object.keys(filterObj).length) {
			this.setState({
				...enableObj,
				filter: { ...this.state.filter, ...filterObj.filter }
			});
		}

  }

  findIndexArr(val, arr) {
    let index = arr.findIndex(item => item.fullName == val)
    return arr[index];
  }

  clearStates() {
    const goalDetails = this.props.goalDetails;
    this.setState({
      teamPermissionSelected: [],
      ownerEn: false,
      teamEn: false,
      permissionstate: (goalDetails.type == 1) ? [10] : [8],
    });
  }

  handleExcludeChange() {
    this.setState({
      Exclude: !this.state.Exclude,
    });
  }

  permissionData(perData) {
    this.setState({
      permissionstate: perData,
    });
  }

  teamPermissionData(teamPerData) {
    this.setState({
      teamPermissionSelected: teamPerData,
    });
  }

  bizPermissionData = (bizPerData) => {
    this.setState({
      bizPermissionSelected: bizPerData
    });
  }

  // eslint-disable-next-line react/sort-comp
  renderError(field) {
    return (
      <ErrorTextComp key={field} errors={this.state.errors} field={field} />
    );
  }

  handleCloseModal() {
    this.props.closeModal();
  }
  
  changeSearchBox(event, term) {
    event.persist();
    this.delayedCalleback(event, term);
  }

  convertOKR() {
    const { t } = this.props;
    console.log('convertOKR')
    const goalDetails = this.props.goalDetails;
    const goalType = goalDetails.type == '1' ? 2 : 1;
    let errors = {};
    if (goalType == '1' && (this.state.team_name == '' || this.state.team_id == '')) {
      errors.team_name = t('Please select the team.');
    }
    if (Object.keys(errors).length) {
      this.setState({ errors });
    }
    else {
      let params = {};
      params.id = goalDetails.id;
      params.team_id = this.state.team_id;
      params.user_id = this.state.owner_id;
      params.permission_teams = this.state.teamPermissionSelected.map(val => val.id);
      params.permission_biz = this.state.bizPermissionSelected.map(val =>  val.id);
      params.type = goalType;
      params.permissionChanged = 1;
      let permissionData = this.state.permissionstate;
      if (permissionData.length == 0 && goalType == '1') {
        params.permission = 7
      } else {
          params.permission = permissionData.join(',');
      }
    reactLoader();
    const _this = this;
    _this.GoalServices.convertOKR(params)
    .then(response => {
        removeReactLoader();
        let {error=''} = response.data;
        if (error) {
            console.log('error -->' + error);
        }
        else {
            console.log('response -->', response.data);
            _this.clearStates();
            _this.props.updateOKR(response.data);
            setTimeout(() => _this.props.closeModal(), 0);
        }
    });
    }
  }

  parentDOM() {
    return document.getElementById('add_goal_page');
  }

  handleOwnerSelect(event, val) {
    event.stopPropagation();
    this.setState({
      owner_name: val.fullName,
      owner_id: val.userId,
      ownerEn: false,
      krOwnerPic: val.picture,
    });
  }

  select(event, valTeam) {
    event.stopPropagation();
    let _this = this;
    _this.setState({
      team_name: valTeam.name,
      team_id: valTeam.id,
      ownerDataSpinner: true,
    });
    _this.GoalServices.getOwnerNamebyTeamID({ teamId: valTeam.id }).then(
      (response) => {
        if (response.data) {
          let ownerData = response.data || [];
          let findDefaultData = ownerData.filter(v => v.role === 1);
          let defaultOwner = findDefaultData.length ? findDefaultData[0] : ownerData[0];
          _this.setState({
            ownerList: [...response.data],
            owner_name: _this.state.owner_name ? (_this.state.owner_id != defaultOwner.userId ? defaultOwner.fullName : _this.state.owner_name) : defaultOwner.fullName,
            owner_id: _this.state.owner_id ? (_this.state.owner_id != defaultOwner.userId ? defaultOwner.userId : _this.state.owner_id) : defaultOwner.userId,
            krOwnerPic: _this.state.krOwnerPic ? (_this.state.owner_id != defaultOwner.userId ? defaultOwner.picture : _this.state.krOwnerPic) : defaultOwner.picture,
            ownerDataSpinner: false,
            teamEn: !_this.state.teamEn,
            filter: {
              Team: [],
            },
          });
        }
      },
    );
  }

  filterTeamFunction(event) {
    let _this = this;
    event.preventDefault();
    let input = document.getElementById('TeamSearch');
    let filter = input.value.trim().toLowerCase();
    if (filter.length > 1) {
      _this.GoalServices.searchTeamName({ term: filter }).then(
        response => {
          if (response.data) {
            // console.log('_this.state.teamSearchVal', _this.state.teamSearchVal);
            _this.setState({
              filter: {
                ..._this.state.filter,
                Team:
                    _this.state.teamSearchVal
                        && _this.state.teamSearchVal.length > 1
                      ? response.data
                      : [],
              },
            });
          }
        },
      );
    } else {
      _this.setState({
        filter: {
          ..._this.state.filter,
          Team: [],
        },
      });
    }
  }

  filterOwnerFunction(event) {
    let _this = this;
    let input = document.getElementById('OwnerSearch');
    let filter = input.value.trim().toLowerCase();
    if (filter.length > 1) {
       let params = {term: filter};
       let tid = this.state.team_id;
       if (tid > 0) {
          params.tid = tid; // allow to search team manager and co manager name
       }
      _this.GoalServices.getOwnerBySearch(params).then(
        response => {
          if (response.data) {
            _this.setState({
              ownerList:
                        _this.state.ownerSearchVal
                            && _this.state.ownerSearchVal.length > 1
                          ? response.data
                          : [],
            });
          }
        },
      );
    } else {
      _this.setState({
        filter: {
          ..._this.state.filter,
          ownerList: [],
        },
      });
    }
  }

  clickOwnerEnable() {
    return !this.state.ownerDataSpinner
      && this.setState({ ownerEn: !this.state.ownerEn });
  }

  render() {
    const { t } = this.props;
    const goalDetails = this.props.goalDetails;
    const goalType = goalDetails.type == '1' ? 2 : 1;
    const isTeamOKR = (goalType == 1);
    const title = isTeamOKR ? t('Team') + t('OKR') : t('Personal OKR');
    const changeProps = {
      type: goalType, 
      permission_teams: [],
      permission: (goalDetails.type == 1) ? '10': '8',
    };
    return (
      <ThemeProvider>
        <StyledModal 
          dismissLabel={t("Cancel")}
          submitLabel={t("Convert")}
          onDismiss={() => this.handleCloseModal()}
          onSubmit={() => this.convertOKR()}
          title={`${t('Convert to')} ${title}`}
          kind="normal"
          isOpen={this.props.isOpen}
          style={{zIndex:"1000000"}}
          data-testid="convertOKR"
          id="add_goal_page"
          className="convert-team-okr-model"
          >
          <div className="react-modal-dialog-wrapper react-modal-convert-okr">
            <div className="react-modal-content">
            <div className="aEdivWidth600">
              {goalType == 1 && (
                <div className="inLineBlk aETeamHead">{t('Team')}</div>
              )}
              <div className="inLineBlk aEOwnerHead">{t('Owner')}</div>
            </div>
            <div className="aEdivWidth600">
              { goalType == 1 && (
                <div className="inLineBlk teamSearch">
                  <div
                    className="aETeamSelect truncate"
                    value={this.state.team_name}
                    onClick={() => {
                      this.setState({ teamEn: !this.state.teamEn });
                    }}
                        >
                    <span className="team-name-span" data-testid="team-name-span">
                      {this.state.team_name}
                    </span>
                    <span className="team-name_arrow arrowDown " />
                  </div>

                  {this.state.teamEn && (
                  <div
                    id="myTeam"
                    className="myTeamDropDown dropdown-content"
                    >
                    <input
                      type="text"
                      placeholder={t("Search for teams")}
                      id="TeamSearch"
                      className="aETeamSearch"
                      onChange={event => this.changeSearchBox(event, 'team')}
                      autoFocus
                        />
                    <div className="teamListsSec" data-testid="teamListsSec">
                      {this.state.filter
                        && this.state.filter.Team
                        && this.state.filter.Team.map(valTeam => (
                          <span
                            key={'team_' + valTeam.id}
                            className="handCur truncate"
                            onClick={e => {
                              this.select(e, valTeam);
                            }}
                            >
                            {valTeam.name}
                          </span>
                        ))}
                    </div>
                  </div>
                  )}
                  {this.renderError('team_name')}
                </div>
              )}

              <div className="ownerSearch inLineBlk">
                {
                  (goalType == 2) ? (
                  <div
                    className="aEOwnerSelect truncate"
                    value={this.state.owner}
                    onClick={() => this.clickOwnerEnable()}
                      >
                    <img src={this.state.krOwnerPic} className="fitProfileImage" alt=""/>
                    <div className="truncate owner-text">
                      {this.state.owner_name}
                    </div>
                    <div className="search-arrow" />
                  </div>
                  ) : '' 
                }
                {this.state.ownerDataSpinner && (
                <div className="Ownerspinner">
                  <ImgIconComp id="loadinggif" />
                </div>
                )}
                { !this.state.ownerDataSpinner
                        && goalType == 1
                        && this.state.ownerList
                        && this.state.ownerList.length > 0 ? (
                           <StyledDropdown
                              aria-label={t("Owner")}
                              initialValue={this.state.owner_name}
                              autoMenuWidth
                              onChange={e => {

                                this.handleOwnerSelect(e, this.findIndexArr(e.target["value"], this.state.ownerList))}

                              }
                              MenuProps={{
                                style: {
                                zIndex: '1500000'
                                },
                                }}
                              optionTitleProp="fullName"
                              optionValueProp="value"
                              options={this.state.ownerList}
                              showStartNodeOnSelect
                            /> 
                  ) : (
                    goalType == 2
                            && this.state.ownerEn
                            && !this.state.ownerDataSpinner && (
                            <div id="myOwner" className="myOwner ">
                              <input
                                type="text"
                                placeholder={t("Search for people")}
                                id="OwnerSearch"
                                className="aEOwnerSearch"
                                onChange={event => this.changeSearchBox(event, 'owner')}
                                autoFocus
                                    />
                              <div className="personal-owner">
                                {this.state.ownerList
                                            && this.state.ownerList.map(val => (
                                              <div className="ownerSec">
                                                <img src={val.picture} />
                                                <span
                                                  className="handCur truncate"
                                                  onClick={e => {
                                                    this.handleOwnerSelect(e, val);
                                                  }}
                                                    >
                                                  {val.fullName}
                                                </span>
                                              </div>
                                            ))}
                              </div>
                            </div>
                    )
                  )}
              </div>
              <div className="clear" />
              <div className="aEPermissionDiv">
                <div className="aEPermissionText">
                    {t('View permissions in addition to')} {goalType == 1 ? t(' team ') : t(' owner ')}
                </div>
                <div
                  className="aEPermissionHelpText"
                  onMouseEnter={() => {
                    this.setState({
                      permissionHelpPopUp: !this.state.permissionHelpPopUp,
                    });
                  }}
                  onMouseLeave={() => {
                    this.setState({
                      permissionHelpPopUp: !this.state.permissionHelpPopUp,
                    });
                  }}
                >
                  {this.state.permissionHelpPopUp && (
                  <div className="form-popup">
                    {`${t('Decide to whom this OKR is transparent.')} ${t('You can make it visible to just this team, the whole organization or choose specific teams.')}`}
                  </div>
                  )}
                </div>
              </div>

              <PermissionComp
                item={{ ...goalDetails }}
                goalDetails={{ ...goalDetails, ...changeProps }}
                teamPermissionData={this.teamPermissionData}
                bizPermissionData={this.bizPermissionData}
                permissionData={this.permissionData}
                Exclude={this.state.Exclude}
                handleExcludeChange={this.handleExcludeChange}
                hide={this.state.hide}
                okr_disabled_org_perm={this.props.okr_disabled_org_perm} 
                hideApplyCheckbox
              />

            </div>
          </div>
          </div>
          </StyledModal>
      </ThemeProvider>
    );
  }
}

export default withTranslation()(ConvertOKRmodal);